import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

import { QUERY_KEYS } from '.';

const getOKRChildrenApi = ({ id }) => {
  const url = endpoints.rabbitGoals.childGoal;

  return sendRequest({
    method: 'GET',
    url,
    queryParams: {
      parentId: id,
    },
    credentials: 'include',
  });
};

export const useGetOKRChildren = ({ id, enabled }) =>
  useQuery(
    [QUERY_KEYS.OKR_CHILDREN, id],
    () =>
      getOKRChildrenApi({
        id,
      }).then((res) => res.entity),
    { enabled }
  );
